module.exports = __webpack_public_path__ + "static/fonction2-a3f192c3d5504309c8b372b36608d21b.jpg";